import { ActionButtonVariants } from 'components/action-button';

export default {
  buttonVariant: ActionButtonVariants.BOX_SHADOW_PRIMARY,
};
